interface SVGColorFilterProps {
	id: string;
	color: string;
}

const SVGColorFilter: React.FC<SVGColorFilterProps> = ({ id, color }) => {
	return (
		<filter id={id}>
			<feColorMatrix
				type="matrix"
				in="SourceGraphic"
				result="grayscale"
				values="0 0 0 0 0
                0 0 0 0 0
                0 0 0 0 0
                1 1 1 0 0"
			/>

			<feFlood id="floodColor" floodColor={color} />
			<feComposite
				in="floodColor"
				in2="grayscale"
				operator="in"
				result="maskedSkin"
			/>
			{/*<feBlend in="SourceGraphic" in2="maskedSkin" mode="overlay" /> */}

			<feBlend
				in="maskedSkin"
				in2="floodColor"
				mode="color"
				result="coloredSkin"
			/>
			<feBlend in="SourceGraphic" in2="coloredSkin" mode="overlay" />
		</filter>
	);
};

export default SVGColorFilter;
